import React, { FC } from 'react'
import styles from 'styles/components/form.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { SelectBox } from './index'
import { DefaultStockType } from 'types/schedule'
import { useSelector } from 'react-redux'
import { getOpenTime, getLastPickupTime } from 'reducks/store/selectors'
import { State } from 'index'
import { DeleteIconButton } from 'components/Button'
import { FirebaseDocRefType } from 'firebase/index'
import { useStockAmountOptions } from 'hooks/stock'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { useEarliestBusinessTime, useLatestOpenTime } from 'hooks/businessHour'
import { useTimesWithRange } from 'hooks/store'
import { StockUnionType } from 'types/stock'

type Props = {
  daysOfWeek: DayOfWeekType[]
  defaultStocks: DefaultStockType[]
  deleteDefaultStock?: (ref: FirebaseDocRefType, defaultStockIndex: number, type: StockUnionType) => void
  deleteSchedule?: (index: number, type: StockUnionType) => void
  handleDefaultStocks: (
    defaultStock: DefaultStockType,
    index: number,
    scheduleRef?: FirebaseDocRefType,
    type?: StockUnionType
  ) => void
  isShownDeleteIcon?: boolean
  index?: number
  scheduleRef?: FirebaseDocRefType
  type?: StockUnionType
}

const DefaultStockForm: FC<Props> = (props) => {
  const {
    daysOfWeek,
    defaultStocks,
    deleteDefaultStock,
    deleteSchedule,
    handleDefaultStocks,
    isShownDeleteIcon,
    index,
    scheduleRef,
    type,
  } = props

  const openTime = useSelector((state: State) => getOpenTime(state))
  const lastPickupTime = useSelector((state: State) => getLastPickupTime(state))
  const latestOpenTime = useLatestOpenTime(daysOfWeek, openTime)
  const earliestLastPickupTime = useEarliestBusinessTime(daysOfWeek, lastPickupTime, 'last_pickup_time')
  const pickupableTimeOptions = useTimesWithRange(latestOpenTime, earliestLastPickupTime)

  const selectPickupableTime = (pickupableTime: string, index?: number) => {
    if (typeof index === 'undefined') return
    handleDefaultStocks(
      {
        pickupable_time: pickupableTime,
        stock: defaultStocks[index].stock,
      },
      index,
      scheduleRef,
      type
    )
  }

  const selectStock = (stock: string, index?: number) => {
    if (typeof index === 'undefined') return
    handleDefaultStocks(
      {
        pickupable_time: defaultStocks[index].pickupable_time,
        stock: Number(stock),
      },
      index,
      scheduleRef,
      type
    )
  }

  const stockOptions = useStockAmountOptions()

  return (
    <div>
      <div className={styles.column_two}>
        <div className={`${styles.column_two__item} ${text.font_small}`}>受渡解禁時刻</div>
        <Spacer size={8} />
        <div className={`${styles.column_two__item} ${text.font_small}`}>
          {type === 'daily' && <span>オープン時在庫数</span>}
          {type === 'preorder' && <span>1日の販売上限数</span>}
        </div>
        {isShownDeleteIcon && <Spacer size={32} axis={'horizontal'} />}
      </div>
      <Spacer size={8} />
      {defaultStocks.map((defaultStock, defaultStockIndex) => {
        return (
          <React.Fragment key={`${defaultStock.pickupable_time}-${defaultStockIndex}`}>
            <div className={styles.column_two}>
              <div className={styles.column_two__item}>
                <SelectBox
                  index={defaultStockIndex}
                  options={pickupableTimeOptions}
                  select={selectPickupableTime}
                  value={defaultStock.pickupable_time}
                />
              </div>
              <Spacer size={8} />
              <div className={styles.column_two__item}>
                <SelectBox
                  index={defaultStockIndex}
                  options={stockOptions}
                  select={selectStock}
                  value={String(defaultStock.stock)}
                />
              </div>
              {isShownDeleteIcon && scheduleRef && type && (
                <>
                  <Spacer size={8} />
                  <DeleteIconButton
                    disabled={defaultStocks.length === 1 && index === 0}
                    onClick={() => {
                      defaultStocks.length === 1 && index !== 0
                        ? deleteSchedule
                          ? deleteSchedule(index ?? 0, type)
                          : null
                        : deleteDefaultStock
                        ? deleteDefaultStock(scheduleRef, defaultStockIndex, type)
                        : null
                    }}
                  />
                </>
              )}
            </div>
            {defaultStockIndex !== defaultStocks.length - 1 && <Spacer size={8} />}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default DefaultStockForm
